import { toUnit } from '@/helpers/toUnit';
import { css } from '@emotion/css';

export const stySkeletonLoading = ({ color, height, width }) => css`
  border-radius: 4px;
  background-color: gray;
  animation: skeleton-loading 0.5s linear infinite alternate;
  background-color: ${color};
  height: ${toUnit(height)};
  width: ${toUnit(width)};

  @keyframes skeleton-loading {
    0% {
      opacity: 0.5;
    }
    100% {
      opacity: 0.9;
    }
  }
`;
